var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ElementRef, EventEmitter, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { config } from '../../../../../config/config';
import { BaseComponent } from '../../../../common/components/base.component';
import { isNullOrUndefined } from '../../../../common/extensions';
import { ImageService } from '../../../../services/image.service';
import { VisitorApiService } from '../../../../services/visitor.api.service';
import { VisitorTripStore } from '../../../../stores/visitor.calendar.store';
var TripMapBottomInfoComponent = /** @class */ (function (_super) {
    __extends(TripMapBottomInfoComponent, _super);
    function TripMapBottomInfoComponent(router, imageService, visitorTripStore, visitorApiService, activatedRoute) {
        var _this = _super.call(this, { activatedRoute: activatedRoute }) || this;
        _this.router = router;
        _this.imageService = imageService;
        _this.visitorTripStore = visitorTripStore;
        _this.visitorApiService = visitorApiService;
        _this.activatedRoute = activatedRoute;
        _this.greenMapIcon = config.detailSelectedMapMarker;
        _this.showDetail = new EventEmitter();
        _this.removeFromTrip = new EventEmitter();
        _this.onClose = new EventEmitter();
        return _this;
    }
    TripMapBottomInfoComponent.prototype.ngOnInit = function () {
        var hubName = this.allRouteParams.hubName;
        this.hubName = hubName;
    };
    Object.defineProperty(TripMapBottomInfoComponent.prototype, "isDetailShowing", {
        get: function () {
            return this.isShowingDetail;
        },
        enumerable: true,
        configurable: true
    });
    TripMapBottomInfoComponent.prototype.gotoDetails = function (item) {
        this.showDetail.emit(item);
    };
    TripMapBottomInfoComponent.prototype.remove = function (item) {
        this.removeFromTrip.emit(item);
        this.isShowingDetail = false;
    };
    TripMapBottomInfoComponent.prototype.show = function () {
        this.isShowingDetail = true;
    };
    TripMapBottomInfoComponent.prototype.close = function () {
        this.isShowingDetail = false;
    };
    TripMapBottomInfoComponent.prototype.isNullOrUndefined = function (value) {
        return isNullOrUndefined(value);
    };
    return TripMapBottomInfoComponent;
}(BaseComponent));
export { TripMapBottomInfoComponent };



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/visitor/trip/trip.map.bottom.info/trip.map.bottom.info.component.ts.pre-build-optimizer.js